import { useState } from "react";
import Modal from 'react-modal';

type LoaderModalProps = {
  hasMessage: boolean;  
  message?: string;
  };
  
  
  
  export default function LoaderModal({
    hasMessage, message
  }: LoaderModalProps) {
    const [modalIsOpen, setIsOpen] = useState(true);
    Modal.setAppElement("#root");

    if(hasMessage &&  !message) {
      message = "Traitement en cours, merci de patienter...";
    }

    return (
      <Modal isOpen={modalIsOpen}>
        <div className="modale open">
          <div className="modale--content">
          <div className="p-md bg-blanc">        
            <div className="p-md ta-center">            
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/loader.gif"} width="80" height="80" style={{boxShadow: "none"}} alt=""/>   
                {hasMessage && <div className="p-md">{message}</div>}
              </div>    
            </div>
          </div>
        </div>
      </Modal>
    );
  }